import React from "react";
import NavBar from "../../components/Navbar/NavBar";


const WaterJetBanner = () => {


    return (
        <>
            <div className="waterJetBanner" id="waterJetBanner">
                <div>
                    <NavBar/>
                </div>

                <div
                    className="m-auto overflow-hidden mx-4 mt-8 lg:mt-4 p-2 md:p-12 h-5/6"
                    data-aos="zoom-in"
                >
                    <div
                        id="hero"
                        className="flex flex-col lg:flex-row py-8 justify-between text-center lg:text-left"
                    >
                        <div
                            className="lg:w-1/2 flex flex-col justify-center "
                            data-aos="zoom-in"
                            data-aos-delay="200"
                        >
                            <h1 className="mb-5 md:text-5xl text-3xl font-bold text-white bannerText">
                                Rezanie vodným lúčom: Presné a ekologické delenie materiálov
                            </h1>
                            <div className="text-xl font-semibold tracking-tight mb-5 text-white bannerText">
                                <p>Ak hľadáte spoľahlivú metódu na rezanie rôznych materiálov,
                                    rezanie vodným lúčom je ideálnou voľbou. Táto moderná technológia ponúka množstvo
                                    výhod, vrátane presnosti, minimálnych deformácií a ekologickej prevádzky.</p>

                            </div>

                        </div>
                        <div
                            className="flex lg:justify-end w-full lg:w-1/2"
                            data-aos="fade-up"
                            data-aos-delay="700"
                        >
                            {/*<img*/}
                            {/*    alt="card img"*/}
                            {/*    className="rounded-t float-right duration-1000 w-full"*/}
                            {/*    src={heroImg}*/}
                            {/*/>*/}
                            <div style={{height: "406px"}}></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default WaterJetBanner;
